import CustomExpandableTable from './../../../../../components/table/CustomExpandableTable';
import RenderExpandedRow from '../SubComponents/RenderExpandedRow';
import RequestSubViewApp from '../Functionality/RequestSubViewApp';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { CheckOutlineIcon } from '../../../../../components/buttons/IconButtons';
import {STATUS_MODEL} from '../../../../../enums/statusEnum';
import NotInformation from '../../../../../components/NotInformation';
import DocumentationHeader from '../../../../DocumentationApprovalFlow/SubComponents/DocumentationHeader';
import CancelModal from '../../../Dining/Schedules/Modal/CancelModal';
import React from 'react';
import {getInfoParagraphByStatus} from '../../../ApprovalTracker/Model/Model';

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

const RequestSubView = (props) => {
    const {
        option,
        subView,
        handleSubViewChange,
        searchElement,
        setSearchElement,
        DEV,
        permission,
        search,
        setSearch,
        setSimpleSearch,
        viewType,
        userTypeId,
        setIsAllChecked
    } = props;
    const {
        t,
        tableId,
        searchId,
        handleCheckboxChange,
        handleDeleteAll,
        rowsPerPage,
        columns,
        handleRowExpand,
        results,
        setResults,
        showApprovedModal,
        setShowApprovedModal,
        selectedList,
        showApproveButton,
        handleChildCheckbox,
        pagination,
        page,
        itemRequest,
        handleApprovalAll,
        rows
    } = RequestSubViewApp({
        searchElement,
        setIsAllChecked,
        option,
        userTypeId
    });

    return (
        <>
            <DocumentationHeader
                page={page}
                searchId={searchId}
                option={option}
                rowsPerPage={rowsPerPage}
                viewType={viewType}
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                DEV={DEV}
                permission={permission}
                setSearchResults={setResults}
                searchResults={results}
                search={search}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                userTypeId={userTypeId}
            />
            <div className='d-flex justify-content-end px-4 mb-3'>
                {showApproveButton && (
                    <ButtonAction
                        Icon={CheckOutlineIcon}
                        id={'btn_rsv_approve'}
                        extraClassName={'border-full-success-600 background-general-00'}
                        className={'border-full-success-600 background-general-00'}
                        iconClass={'h-32px w-32px mr-0'}
                        iconProps={'icon'}
                        onClick={() => {
                            setShowApprovedModal(true);
                        }}
                    />
                )}
            </div>

            {results?.content?.length > 0 ? (
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        id={tableId}
                        columns={columns}
                        rows={rows}
                        renderExpandedRow={(props) => (
                            <RenderExpandedRow
                                row={itemRequest}
                                onSelectItem={handleChildCheckbox}
                                selectedList={selectedList}
                                canApprove={!!props.row.canApprove}
                                userTypeId={userTypeId}
                            />
                        )}
                        onRowExpand={handleRowExpand}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        rowsPerPage={rowsPerPage}
                        checkbox={false}
                        rowClassName={(row) => (row.canApprove ? 'background-secondary-50 background-hover-secondary-100 box-shadow-secondary-400-full' : '')}
                        showHeader={false}
                    />
                    {pagination()}
                </>
            ) : (
                <NotInformation text={t('no_requests_found')} card={true} />
            )}

            {showApprovedModal && (
                <CancelModal
                    show={showApprovedModal}
                    onHide={() => setShowApprovedModal(false)}
                    onConfirm={(e, comment) => {
                        handleApprovalAll(comment)
                    }}
                    requiredComment={false}
                    title_modal={"approve_request"}
                    description={t("are_you_sure_to_proceed")}
                    subDescription={t(getInfoParagraphByStatus(STATUS_MODEL.APPROVED))}
                />
            )}
        </>
    );
};

export default RequestSubView;
